import {
  SimpleGridProps as MantineSimpleGridProps,
  SimpleGrid as MantineSimpleGrid,
} from '@mantine/core';

export type SimpleGridProps = MantineSimpleGridProps;

export const SimpleGrid = MantineSimpleGrid;

SimpleGrid.displayName = 'SimpleGrid';
